import React from "react";



const JennieTestimonial = () => {
    return (
        <div className="Testimony">
            <img src="/images/image-jennie.jpg" alt="jennie" />
            <section className="quotes">
                <p>Incredible end results! Our sales increased over 400% wehen we worked with Sunnyside. Highly recommended!</p>
                <section className="name-title">
                    <span>Jennie F.</span>
                    <span>Business Owner</span>
                </section>
            </section>
        </div>
    );
}

export default JennieTestimonial